import {
    booleanAttribute,
    ChangeDetectionStrategy,
    Component,
    Input,
    ViewEncapsulation
} from '@angular/core';
import { SanitizeHtmlPipe } from '../../pipes/sanitize-html.pipe';
import { ContentBlock } from './models/content-block.types';

@Component({
    selector: 'nw-content-block',
    imports: [SanitizeHtmlPipe],
    templateUrl: './content-block.component.html',
    styleUrl: './content-block.component.scss',
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.OnPush
})
export class ContentBlockComponent {
    @Input() content?: string;
    @Input() heading?: string;
    @Input() subheading?: string;
    @Input() cards?: ContentBlock.Card[];
    @Input({ transform: booleanAttribute }) border: boolean = false;
    @Input({ transform: booleanAttribute }) transparentBackground: boolean = false;
}
